import adminChronograf from './chronograf'
import adminInfluxDB from './influxdb'

export default {adminChronograf, adminInfluxDB}
